import { injectReducer } from "store/reducers";
import WeeklyPlanning from "./routes/WeeklyPlanning";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
export default store => ({
  path: "class-planners",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "class-planners" */ "./components"),
        import(
          /* webpackChunkName: "class-planners" */ "ClassPlanners/modules/ClassPlannersModule"
        ),
      ]).then(([importedModule0, importedModule1]) => {
        const component = importedModule0.default;
        const reducer = importedModule1.default;
        injectReducer(store, {
          key: "classPlanner",
          reducer,
        });
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [WeeklyPlanning(store)],
});
